"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = void 0;
var debounce = function (func, delay, thisContext) {
  var timer;
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var callback = function () {
      timer = null;
      func.apply(thisContext || null, args);
    };
    clearTimeout(timer);
    timer = setTimeout(callback, delay);
  };
};
exports.debounce = debounce;